module.exports = __webpack_public_path__ + "img/company-img7.d18a030f.png";